import { render, staticRenderFns } from "./LinkToCodeExchangeBanner.vue?vue&type=template&id=6c1be69d&scoped=true&"
import script from "./LinkToCodeExchangeBanner.vue?vue&type=script&lang=js&"
export * from "./LinkToCodeExchangeBanner.vue?vue&type=script&lang=js&"
import style0 from "./LinkToCodeExchangeBanner.vue?vue&type=style&index=0&id=6c1be69d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1be69d",
  null
  
)

export default component.exports